import { supabase } from "@/integrations/supabase/client";

/**
 * The member's last core activity BEFORE today's Israel midnight, or null.
 *
 * "Before today" is decided in SQL (get_my_last_core_activity), so the device
 * clock plays no part. Null also covers every failure, including the migration
 * not being applied yet: the Home card then simply stays hidden.
 */
export async function fetchLastCoreActivityBeforeToday(effectiveUserId: string): Promise<string | null> {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- untyped until Lovable regenerates types.ts
    const { data, error } = await (supabase.rpc as any)("get_my_last_core_activity", {
      p_user_id: effectiveUserId,
    });
    if (error) return null;
    return typeof data === "string" ? data : null;
  } catch {
    return null;
  }
}
